export class ActivityStatModel{
    public value:string;
    public label:string;
}
